import { render, staticRenderFns } from "./discountsVerification.vue?vue&type=template&id=0b1c7b24&scoped=true"
import script from "./discountsVerification.vue?vue&type=script&lang=js"
export * from "./discountsVerification.vue?vue&type=script&lang=js"
import style0 from "./discountsVerification.vue?vue&type=style&index=0&id=0b1c7b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c7b24",
  null
  
)

export default component.exports